export default __webpack_public_path__ + "static/media/sweetlime.83f77585.png";